/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-26 15:09:20
 * @LastEditTime: 2019-10-22 17:18:55
 * @LastEditors: Please set LastEditors
 */
import axios from "axios";
import qs from "qs";
axios.defaults.timeout = 500000;
axios.defaults.withCredentials = true;
//http request 拦截器

axios.interceptors.request.use(
  (config) => {
    config.data = qs.stringify(config.data);
    config.headers = {
      "Content-Type": "application/x-www-form-urlencoded",
      accept: "application/json",
    };
    // localStorage.setItem(
    //   "access_tokens",
    //   "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImFjOWNjZjNjNjE3YzI0YTA2Y2MyMzRkZThmMjIyMWQzN2M5ODNmZWNlZjUzODNlODJjODUwMzg2NDA4ZjU1NTA1NTU5NDYzYWU0MDAwNjZhIn0.eyJhdWQiOiIxMDA4ODAwMyIsImp0aSI6ImFjOWNjZjNjNjE3YzI0YTA2Y2MyMzRkZThmMjIyMWQzN2M5ODNmZWNlZjUzODNlODJjODUwMzg2NDA4ZjU1NTA1NTU5NDYzYWU0MDAwNjZhIiwiaWF0IjoxNzY0NzI1OTE2LCJuYmYiOjE3NjQ3MjU5MTYsImV4cCI6MTc2NjAyMTkxNiwic3ViIjoiMSIsInNjb3BlcyI6WyIqIl19.ERwcYKvdeycKZ_QZP-T_zoQ3xsdTlxHWkcYh65YHPdiKno96NFsBSbgkK3dkDxAsrgQ2-4Je1XyZgAbGygBRTgS0AuhiAV0rvn-zAKPgL1DKc1U3XQTSHTTlbRLDY3H_0-uSgT0GrvjYcUeymvBOAYsGZPfk2oFs5bxunbRJoJXjPnaO3UgBCehHacgs-GRw0oDTdOzGBEcvPoc88v8iX4Lq0QEgxVOcOoi8BlAfCznsSKUnvXdBMGQmb0-MmTtwbq-q8qnGkPv1mUTu6SXiAgQ9WX-aAIvCZn0aH3MCz9zHvU0Jjp1y1pyveKMseS_R2xVBFn2RH3P1RzIi5ZmvmHSoAPE4MJqsQCthwZm_xZsw5JqDPNpMhdwb-ibHmA3JNbt_w_Kz6fh55XZtGL35aokjUjGmY3_V3Lz8C_JHx2Dz0ozJWacOw1fKxCYZ9prAob_-JfZRSni4-f0mNhxB9RDWUEB0-rduOlM-BWptkMRToL8yoAHIyaKO3orF9P85xZCgkKnlQGcqpFruz_y3deFjRU3qCm26c_cl8kvmOWAgv92DWEmlX8WUNwq8f4Ha2JfmdalwupdxlWUQxfsJX8sOAWjaa9t1A9osZ6kO2UzTv1iOsUoEUNq_BaJLF8Rg8ftKGW8lutsFaXtEwKYqz7quRiGJVAPfCP1u1s1xUTo"
    // );
    config.headers.Authorization =
      "Bearer" + " " + localStorage.getItem("access_tokens");
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
//http response 拦截器
axios.interceptors.response.use(
  (response) => {
    if (response.data.code == 100) {
      location.href = location.href.split("#/")[0] + "#/login"; //跳回登陆页面
    }
    return response;
  },
  (error) => {
    if (error.data) {
      return Promise.reject(error.data);
    } else {
      return Promise.reject(error.response.data);
    }
  }
);

//定义全局的api
let api;

if (process.env.VUE_APP_type == "development") {
  api = {
    logistics: "http://logistics.com:8088/admin/v2",
    logistics_2: "http://pps.qwe.com/index.php/",
    pda: "http://logistics.com:8088/pda/v2/",
  };
} else if (process.env.VUE_APP_type == "production") {
  api = {
    logistics: "https://logistics.tx315.vip/admin/v2",
    logistics_2: "https://pps.tx315.vip/index.php/",
    pda: "https://logistics.tx315.vip/pda/v2/",
  };
}

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function fetch(module, url, params = {}) {
  let baseUrl = "";
  if (module == "logistics") {
    baseUrl = api.logistics + url;
  } else if (module == "logistics_2") {
    baseUrl = api.logistics_2 + url;
  } else if (module == "pda") {
    baseUrl = api.pda + url;
  }
  return new Promise((resolve, reject) => {
    axios
      .get(baseUrl, {
        params: params,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(module, url, data = {}) {
  if (module == "logistics") {
    url = api.logistics + url;
  } else if (module == "logistics_2") {
    url = api.logistics_2 + url;
  } else if (module == "pda") {
    url = api.pda + url;
  }
  return new Promise((resolve, reject) => {
    axios.post(url, data).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(module, url, data = {}) {
  if (module == "logistics") {
    url = api.logistics + url;
  } else if (module == "logistics_2") {
    url = api.logistics_2 + url;
  } else if (module == "pda") {
    url = api.pda + url;
  }
  return new Promise((resolve, reject) => {
    axios.patch(url, data).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(module, url, data = {}) {
  if (module == "logistics") {
    url = api.logistics + url;
  } else if (module == "logistics_2") {
    url = api.logistics_2 + url;
  } else if (module == "pda") {
    url = api.pda + url;
  }
  return new Promise((resolve, reject) => {
    axios.put(url, data).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}
/**
 * 封装delete请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function del(module, url, data = {}) {
  if (module == "logistics") {
    url = api.logistics + url;
  } else if (module == "logistics_2") {
    url = api.logistics_2 + url;
  } else if (module == "pda") {
    url = api.pda + url;
  }
  return new Promise((resolve, reject) => {
    axios.delete(url, data).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}
